import { connect } from 'react-redux'
import { createTable, updateTable } from 'redux/modules/table'
import { createBar } from 'redux/modules/bar'
import {
  addSideTable,
  addConso,
  removeSideTable,
  updateTransaction,
  playTransaction,
  pauseTransaction,
  transfertTransaction,
  prepareForPayment,
  addPayment,
  removePayment,
  closeTransaction
} from 'redux/modules/transaction'

import HomeComponent from '../components/HomeComponent.js'

const mapActionCreators = {
  createTable,
  updateTable,
  createBar,
  addSideTable,
  addConso,
  removeSideTable,
  updateTransaction,
  playTransaction,
  pauseTransaction,
  transfertTransaction,
  prepareForPayment,
  addPayment,
  removePayment,
  closeTransaction
}

const mapStateToProps = state => {
  return {
    bars: state.bars.list,
    tables: state.tables.list,
    products: state.products.list,
    categories: state.categories.list,
    currentPricing: state.pricings.currentPricing,
    ticket: state.settings.ticket,
    map: state.settings.size,
    transactions: state.transactions.list,
    sidedTransactions: state.transactions.sidedList,
    allConsos: state.consos.list
  }
}

export default connect(mapStateToProps, mapActionCreators)(HomeComponent)



// WEBPACK FOOTER //
// ./src/routes/Home/containers/HomeContainer.js